export default __webpack_public_path__ + "static/media/ceramx-indirect-restoration-ceramx.8e115392.png";